/**
 * Contrato PWA por tenant (definido no master, exposto em /api/config).
 */
let contracted = false;
const listeners = new Set();

export function setTenantCandidatePwaContracted(value) {
  const next = Boolean(value);
  if (next === contracted) return;
  contracted = next;
  listeners.forEach((fn) => fn(next));
}

export function getTenantCandidatePwaContracted() {
  return contracted;
}

export function subscribeTenantCandidatePwaContracted(fn) {
  listeners.add(fn);
  fn(contracted);
  return () => listeners.delete(fn);
}

export function applyTenantPwaFromConfig(cfg) {
  setTenantCandidatePwaContracted(cfg?.candidate_pwa_contracted);
}
